import { createTheme, Theme } from "@mui/material";

export const primaryColor = '#012b65'
export const theme: Theme = createTheme({
  palette: {
    primary: {
      main: '#012b65',
    },
    secondary: {
      main: '#60c5db',
    },
    error: {
      main: '#fe144a',
    },
    text: {
      primary: '#00559c',
    },
    
  },
  typography: {
    fontFamily: ['Playfair Display', '"Helvetica Neue"', 'Arial', 'sans-serif'].join(','),
    button: {
      fontFamily: '"Playfair Display", serif',
    },
    body1: {
      fontFamily: '"Barlow", sans-serif'
    },
  },
});

export default theme;
